import { render, staticRenderFns } from "./FlecheLogo.vue?vue&type=template&id=70fc10f5&"
import script from "./FlecheLogo.vue?vue&type=script&lang=js&"
export * from "./FlecheLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports